<div class="stack" role="region" aria-label="Уведомления">
    @for (item of items(); track item.id) {
        <app-notification-card
            [notification]="item"
            (dismissed)="dismiss($event)"
            animate.enter="stack__item--enter"
            animate.leave="stack__item--leave"
        />
    }
</div>
